// extracted by mini-css-extract-plugin
export var searchHeader = "_2r-0";
export var searchHeaderDark = "_2r-1";